import React from "react";
import { Button, Divider, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from "react-router-dom/cjs/react-router-dom";

const StyledListItem = styled(ListItem)(({ theme }) => ({
  color: 'inherit!important',
  textDecoration: 'none!important',
  height: 80,
  width: '100%',
  borderRadius: 6,
  paddingLeft: 12,
  paddingRight: 12,
  marginBottom: 4,
  '&.active': {
    backgroundColor:
      theme.palette.mode === 'light'
        ? 'rgba(0, 0, 0, .05)!important'
        : 'rgba(255, 255, 255, .1)!important',
    pointerEvents: 'none',
    '& .list-item-icon': {
      color: 'inherit',
    },
  },
  '& .list-item-icon': {
    fontSize: 16,
    width: 16,
    height: 16,
    marginRight: 16,
  },
}));


function PersonalizeBannersSidebarContent(props) {
  const { allBanners, setDefaultBanner, setDefaultBannerNoLog, tipoBanner, newBanner, currentBannerTimeStamp } = props;

  return (
    <div className="flex-auto border-l-1 border-solid" style={{ padding: '0px' }}>
      <div className="px-12">
        <List>
          {(currentBannerTimeStamp && currentBannerTimeStamp != '') && <Button
            className="whitespace-nowrap mx-4"
            variant="contained"
            color="primary"
            onClick={() => newBanner()}

          >
            Nuovo Banner
          </Button>}

          {allBanners && allBanners.length > 0 &&
            <Divider>Lista Banners inseriti</Divider>
          }

          {allBanners && allBanners.length > 0 &&
            allBanners.map((_element) => (
              <StyledListItem
                button
                id={_element.timeStamp}
                key={_element.timeStamp}
                // onClick={() => alert('sono ioooo')}
                component={Link}
                to={`/personalizzaBanners/${_element.timeStamp}`}
              //to={`/apps/todo/${routeParams.id}/folderHandle/${label.handle}`}
              /// key={_state.handle}
              >
                {/*<Icon className="list-item-icon" color="action"> {_state.icon} </Icon>*/}

                <img id={"immagineGrandex"}
                  style={{ height: 75, width: null, padding: 2, margin: 2, cursor: "pointer", }}
                  src={_element?.bannerImageScroll?.[0]?.image ? _element.bannerImageScroll[0].image : "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg"}></img>



                <ListItemText
                  primary={_element.bannerName}
                  secondary={tipoBanner.find((_tipoBanner) => _tipoBanner.id === _element.bannerType)?.description}
                />

                <button type="button" style={{ borderColor: 'transparent' }}
                  onClick={(ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    ///alert('ciao');
                    setDefaultBannerNoLog(_element.timeStamp, !_element.defaultBannerNoLog);
                  }}
                >
                  <i className="fa fa-user-times fa-2x" style={_element.defaultBannerNoLog ? { color: "blue" } : { color: "black" }}></i>
                </button>

                <button type="button" style={{ borderColor: 'transparent' }}
                  onClick={(ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    ///alert('ciao');
                    setDefaultBanner(_element.timeStamp, !_element.defaultBanner);
                  }}
                >
                  <i className="fa fa-star fa-2x" style={_element.defaultBanner ? { color: "blue" } : { color: "black" }}></i>
                </button>


              </StyledListItem>))
          }
        </List>
        <Divider />



      </div>
    </div>
  );
}


export default PersonalizeBannersSidebarContent;
